export default `
  mutation revokeCustomerToken {
    revokeCustomerToken {
      result
    }
  }
`
